import React, { Fragment, memo, useState } from "react";
import { useForm } from "react-final-form";
import { useNotify, useMutation, Button, useRedirect } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Typography,
} from "@material-ui/core";

interface SaveButtonProps {
  invalid: boolean;
  isCalculationButtonClicked: boolean;
}

const SaveButton = ({
  invalid,
  isCalculationButtonClicked,
}: SaveButtonProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const notify = useNotify();
  const redirect = useRedirect();
  const formValues = useForm().getState().values;
  const classes = useStyles();

  const [checkExistingStudent, { loading }] = useMutation(
    {
      type: "create",
      resource: "students/checkExistingStudents",
      payload: {
        data: {
          uniqueCode: formValues.uniqueCode,
          dateOfBirth: formValues.dateOfBirth,
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        if (res.json.length === 0) {
          saveChild();
          return;
        }
        setOpen(true);
      },
      onFailure: (error) => {
        notify(
          `Failed Check existing student, error: ${error.message}`,
          "warning"
        );
      },
    }
  );

  const [saveChild, { loading: loadingSave }] = useMutation(
    {
      type: "create",
      resource: "students",
      payload: {
        data: {
          parentId: formValues.parentId,
          schoolId: formValues.schoolId,
          levelId: formValues.levelId,
          levelGroupId: formValues.levelGroupId
            ? formValues.levelGroupId
            : null,
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          photoUrl: formValues.photoUrl
            ? formValues.photoUrl.url &&
              (formValues.photoUrl.url as string).split(",")[1]
            : null,
          gender: formValues.gender,
          macAddress: formValues.macAddress ? formValues.macAddress : null,
          dateOfBirth: formValues.dateOfBirth,
          status: "active",
          uniqueCode: formValues.uniqueCode,
          dropOffAuth: formValues.dropOffAuth ? formValues.dropOffAuth : false,
          medicalCondition: formValues.medicalCondition,
          studentSchedule: formValues.isNotTakeSchedule
            ? null
            : {
                academicYearId: formValues.academicYearId,
                startedAt: formValues.date,
                isTaking: true,
                detail: {
                  lat: formValues.locationData?.LATITUDE,
                  lng: formValues.locationData?.LONGITUDE,
                  street: formValues.street,
                  unitNumber: formValues.unitNumber
                    ? formValues.unitNumber
                    : null,
                  blockNumber: formValues.blockNumber,
                  postalCode: formValues.postalCode,
                  building: formValues.building,
                  isMonday: formValues.isMonday ? true : false,
                  isTuesday: formValues.isTuesday ? true : false,
                  isWednesday: formValues.isWednesday ? true : false,
                  isThursday: formValues.isThursday ? true : false,
                  isFriday: formValues.isFriday ? true : false,
                  isFromSchool:
                    formValues.wayType === "OneWayMorning" ? false : true,
                  isToSchool:
                    formValues.wayType === "OneWayAfternoon" ? false : true,
                },
              },
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        notify(`Successfully saved student`, "info");
        setOpen(false);
        redirect(`/parents/${res.json.parent.id}/show/2`);
      },
      onFailure: (error) => {
        notify(`Failed saved the student, error: ${error.message}`, "warning");
      },
    }
  );

  return (
    <>
      <Button
        label={loading || loadingSave ? `Loading...` : `Save`}
        disabled={
          loading ||
          loadingSave ||
          invalid ||
          (formValues.isNotTakeSchedule ? false : !isCalculationButtonClicked)
        }
        onClick={checkExistingStudent}
      >
        <SaveIcon />
      </Button>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          Overwrite Confirmation
        </DialogTitle>
        <DialogContent>
          <Typography>
            NRIC + DOB is not unique, would you like to overwrite it?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={saveChild}
            color="primary"
            undoable={false}
            label={loading || loadingSave ? `Loading...` : `Yes`}
            disabled={loading || loadingSave}
          />
          <Button
            onClick={() => {
              setOpen(false);
            }}
            color="secondary"
            label="Cancel"
            className={classes.cancelButton}
            disabled={loading || loadingSave}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  cancelButton: {
    backgroundColor: "#eeeeee",
    color: "black",
  },
});

export default memo(SaveButton);
